import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { DigitalIdAddActivationComponent } from "./digital-id-add-activation/digital-id-add-activation.component";
import { DigitalIdDebugQrCodeComponent } from "./digital-id-debug-qr-code/digital-id-debug-qr-code.component";
import { DigitalIdModifyActivationComponent } from "./digital-id-modify-activation/digital-id-modify-activation.component";
import { DataService_DigitalIDActivations } from "./shared/data.service";

@Component({
	selector: "app-digital-id-activations",
	templateUrl: "./digital-id-activations.component.html",
	styleUrls: ["./digital-id-activations.component.css"],
})
export class DigitalIdActivationsComponent implements OnInit {
	constructor(
		private userService: UserService,
		private DigitalIDActivationService: DataService_DigitalIDActivations,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadSchool();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	Processing: boolean = false;

	ToggleText: string = "Deactivate School";

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchool: any;
	lstSchool: any = [];

	//Filter lists
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "SchoolFullName", header: "School" },
		{ field: "AvailableCount", header: "Available Count" },
		{ field: "TotalCount", header: "Total Count" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchool() {
		this.loading = true;

		var result = this.DigitalIDActivationService.ActivationSelectList();
		result.subscribe(
			(response) => {
				this.loading = false;

				this.lstSchool = response;

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstSchool.map((item: any) => item.ActiveDesc)));
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.errorMessage = "";
		this.SelectedSchool = null;
		this.loadSchool();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		if (this.user == undefined || this.user.userID != 0) {
			return;
		}

		var ref = this.dialogService.open(DigitalIdAddActivationComponent, {
			header: "Add Activation",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSchool();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.user == undefined || this.user.userID != 0) {
			return;
		}

		if (this.SelectedSchool == undefined) {
			this.errorMessage = "Select a school to edit";
			return;
		}

		var ref = this.dialogService.open(DigitalIdModifyActivationComponent, {
			header: "Edit Activation",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				School: this.SelectedSchool,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSchool();
			}
		});
	}

	onDeactivate() {
		this.errorMessage = "";

		if (this.user == undefined || this.user.userID != 0) {
			return;
		}

		//Error handling
		if (this.SelectedSchool == undefined) {
			this.errorMessage = "Select an activation to toggle active";
			return;
		}

		this.Processing = true;

		var changeTo = this.SelectedSchool.Active == true ? 0 : 1;

		//Call SP
		var result = this.DigitalIDActivationService.ActivationToggle(this.SelectedSchool.SchoolID, changeTo);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					this.onRefresh();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not toggle the activation",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDelete() {
		this.errorMessage = "";

		if (this.user == undefined || this.user.userID != 0) {
			return;
		}

		//Error handling
		if (this.SelectedSchool == undefined) {
			this.errorMessage = "Select an activation to delete";
			return;
		}

		this.Processing = true;

		//Call SP
		var result = this.DigitalIDActivationService.ActivationDelete(this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					this.onRefresh();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the activation",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDebugQR() {
		this.errorMessage = "";

		if (this.user == undefined || this.user.userID != 0) {
			return;
		}

		var ref = this.dialogService.open(DigitalIdDebugQrCodeComponent, {
			header: "Debug QR Code",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSchool();
			}
		});
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSchool = val.data;

		this.ToggleText = "Deactivate School";
		if (this.SelectedSchool.Active == false) {
			this.ToggleText = "Activate School";
		}
	}
	onRowUnselect(val) {
		this.SelectedSchool = null;
		this.ToggleText = "Deactivate School";
	}
	onRowDblClick(School) {
		this.SelectedSchool = School;

		this.ToggleText = "Deactivate School";
		if (this.SelectedSchool.Active == false) {
			this.ToggleText = "Activate School";
		}

		this.onEdit();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////
	IsLoading() {
		return this.loading == true || this.Processing == true;
	}
	////////////////////////////////////////////
}
